function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-13.000000, 0.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(13.000000, 0.000000)"
}, React.createElement("path", {
  d: "M14.2343514,8.74170989 L18.1920435,15.4393427 C18.4730069,15.9148193 18.3153229,16.5280351 17.8398463,16.8089985 C17.6857697,16.9000438 17.510083,16.948072 17.3311169,16.948072 L9.41573273,16.948072 C8.86344798,16.948072 8.41573273,16.5003567 8.41573273,15.948072 C8.41573273,15.769106 8.46376094,15.5934193 8.55480621,15.4393427 L12.5124983,8.74170989 C12.7934618,8.2662333 13.4066776,8.10854923 13.8821542,8.38951268 C14.0273793,8.47532755 14.1485365,8.59648472 14.2343514,8.74170989 Z",
  fill: "#FFFFFF",
  transform: "translate(13.373565, 12.974036) rotate(90.000000) translate(-13.373565, -12.974036) "
}), React.createElement("circle", {
  stroke: "#FFFFFF",
  strokeWidth: 2,
  cx: 12.5,
  cy: 12.5,
  r: 11.5
}))));

const SvgGoSereneIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "25px",
  height: "25px",
  viewBox: "0 0 25 25",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgGoSereneIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/go-serene-icon.9894a7eb.svg";
export { ForwardRef as ReactComponent };